export default __webpack_public_path__ + "static/media/loaderIcons.02fcbe65.gif";